import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import {
  DropDownItem,
  UdInteractBookmarks,
  US_SubHeader,
} from "../../api/models";
import { ShareState } from "../../elements/share-editor/share-editor.component";

export interface EditInteractiveBookmarkDialogData {
  userSubscriptions: US_SubHeader[];
  bookmark: UdInteractBookmarks;
  shareState: ShareState;
  isNew: boolean;
  isOwner: boolean;
  updateData: boolean;
}

@Component({
  selector: "edit-interactive-bookmark-dialog",
  templateUrl: "./edit-interactive-bookmark-dialog.component.html",
})
export class EditInteractiveBookmarkDialogComponent implements OnInit {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<EditInteractiveBookmarkDialogData>,
    @Inject(MAT_DIALOG_DATA) public data: EditInteractiveBookmarkDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = data;
  }
  ngOnInit(): void {}

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }
}
